import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=1937fe2f"
import script from "./switch.vue?vue&type=script&lang=ts"
export * from "./switch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1937fe2f')) {
      api.createRecord('1937fe2f', component.options)
    } else {
      api.reload('1937fe2f', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=1937fe2f", function () {
      api.rerender('1937fe2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/switch.vue"
export default component.exports